import React from "react";
import { Paper, Typography, Divider, Grid } from "@mui/material";

const ViewEquipment = ({ equipment }) => {
  if (!equipment) return null;

  const formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString("en-US") : "-";
  };

  const safe = (val) => (val ?? "-");

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Equipment Overview
      </Typography>

      <Divider sx={{ mb: 3 }} />

      {/* ================= BASIC INFO ================= */}
      <Typography variant="h6" sx={{ mb: 1 }}>
        Basic Information
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          Item ID: {safe(equipment.itemId)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Asset ID: {safe(equipment.assetId)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Item: {safe(equipment.item)}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          Description: {safe(equipment.description)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Make: {safe(equipment.make)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Model: {safe(equipment.model)}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          Serial Number: {safe(equipment.serialNumber)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Equipment Type: {safe(equipment.equipmentType)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Location: {safe(equipment.location)}
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* ================= LIFECYCLE ================= */}
      <Typography variant="h6" sx={{ mb: 1 }}>
        Lifecycle
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          Date Received: {formatDate(equipment.dateReceived)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Date Commissioned: {formatDate(equipment.dateCommissioned)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Age: {safe(equipment.age)}
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* ================= FINANCIAL ================= */}
      <Typography variant="h6" sx={{ mb: 1 }}>
        Financial
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          Purchase Price: {safe(equipment.purchasePrice)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Current Value: {safe(equipment.currentValue)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Salvage Value: {safe(equipment.salvageValue)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Depreciation Life: {safe(equipment.depreciationLife)}
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* ================= WARRANTY ================= */}
      <Typography variant="h6" sx={{ mb: 1 }}>
        Warranty & Status
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          Warranty Status: {safe(equipment.warrantyStatus)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Warranty Expiration: {formatDate(equipment.warrantyExpiration)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Equipment Status: {safe(equipment.equipmentStatus)}
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* ================= CALIBRATION ================= */}
      <Typography variant="h6" sx={{ mb: 1 }}>
        Calibration Details
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          Calibration Service Provider: {safe(equipment.calibrationServiceProvider)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Analyst: {safe(equipment.analyst)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Date Calibrated: {formatDate(equipment.dateCalibrated)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Expiration Date: {formatDate(equipment.expirationDate)}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          Thermometer 1: {safe(equipment.thermometer1)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Thermometer 2: {safe(equipment.thermometer2)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Thermometer 3: {safe(equipment.thermometer3)}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          Low Temp: {safe(equipment.lowTemp)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          High Temp: {safe(equipment.highTemp)}
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      {/* ================= SYSTEM ================= */}
      <Typography variant="h6" sx={{ mb: 1 }}>
        System Info
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          Vendor: {safe(equipment.vendor)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Equipment Manual: {safe(equipment.equipmentManual)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Validation Records: {safe(equipment.validationRecords)}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          Record ID: {safe(equipment.recordid)}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ViewEquipment;